<div cdkTrapFocus aria-live="assertive">
  <div class="modal-header">
    <h3 class="modal-title" i18n="@@modalErrorOccurredTitle" id="no-cc-modal-header">
      An error occurred!
    </h3>
    <button
      type="button"
      class="close"
      attr.aria-label="Close"
      ngbAutoFocus
      i18n-aria-label
      (click)="OK()"
    >
      <span aria-hidden="true"><i class="ico-cancel modal_exit_cross"></i></span>
    </button>
  </div>
  <div class="modal-body">
    @if (isSabre) {
      <p i18n="@@modalNoCCErrorMessageUpdateProfileInProfileManagementTool">
        Your profile has incomplete information that could cause the
        {{ serviceType | translate | lowercase }} booking to fail. Please update your Profile in the
        Profile Management Tool and try again.
      </p>
    } @else {
      <p i18n="@@modalNoCCErrorMessage">
        Unable to retrieve any saved credit cards in your travel profile for
        {{ serviceType | translate | lowercase }}, to continue with your booking please update this
        via your profile management tool.
      </p>
    }
  </div>
  <div class="modal-footer">
    <button type="button" class="modal_button_okay" (click)="OK()" i18n="@@modalOK">
      Ok
    </button>
  </div>
</div>
